import axios from 'axios'

export const getApiError = (error: unknown, fallback: string): string => {
  if (axios.isAxiosError(error)) {
    return error.response?.data?.errors?.[0]?.detail || fallback
  }
  return fallback
}
